// src/Pages/WarningTermsPage.jsx
import React from 'react'
import { Link } from "react-router-dom"; 

export const WarningTermsPage = () => {
  return (
    <main className="grid"> 
      <div className="warningTermsPage">
        <h1>Terms of Use, Acceptable Use & Disclaimer</h1>
        <p><strong>Effective date:</strong> August 26, 2025 <br /><br />
            <Link to="/vilkaar" className="contact-link">View Terms in Danish</Link>
        </p>

        <h2>1. No Personal Data / Public Demo Environments</h2>
        <ul>
          <li><strong>Do not submit personal, sensitive, or confidential data.</strong> Do not include real names, phone numbers, email addresses, street addresses, government IDs, financial, health, or other identifying information.</li>
          <li><strong>Public visibility:</strong> Demo databases, shared CSVs/RAFs, and other sample storage may be visible to other users and can be modified or deleted at any time.</li>
          <li><strong>Your responsibility:</strong> You are solely responsible for what you enter, upload, or generate while using the software or services.</li>
        </ul>

        <h2>2. Acceptable Use (What you must not do)</h2>
        <ol>
          <li>Use the software, databases, or site for any <strong>unlawful</strong> purpose or to violate any applicable law or regulation;</li>
          <li>Upload, post, store, or transmit unlawful, defamatory, abusive, harassing, hateful, threatening, or otherwise objectionable material;</li>
          <li>Infringe or violate intellectual property, privacy, or publicity rights;</li>
          <li>Attempt to breach security, reverse-engineer, decompile, or otherwise access source code or non-public systems;</li>
          <li>Transmit malware, spyware, or any code of a destructive or intrusive nature;</li>
          <li>Interfere with or disrupt the operation of the site, apps, or databases;</li>
          <li>Misrepresent your identity or your affiliation with any person or entity;</li>
          <li>Use data from the demo environment for spam, scraping, profiling, or any commercial exploitation.</li>
        </ol>

        <h2>3. User Content & Ownership</h2>
        <p>You retain ownership of content you submit where you have such rights. You grant the developer a limited, non-exclusive license to host, display, and process your content solely for demonstration, testing, and operation of the demo environment. You represent that you have the rights to submit any content you provide and that it does not violate these Terms.</p>

        <h2>4. Security & Data Handling</h2>
        <p>These demo environments are <strong>not</strong> designed for production use. There is no guarantee of confidentiality, integrity, or availability of any data. Back up anything you wish to keep.</p>

        <h2>5. “AS IS” — No Warranties</h2>
        <p>The website, software, sample files, and any demo databases are provided <strong>“AS IS”</strong> and <strong>“AS AVAILABLE”</strong> without warranties of any kind, whether express, implied, or statutory, including but not limited to merchantability, fitness for a particular purpose, non-infringement, accuracy, or availability.</p>

        <h2>6. Limitation of Liability</h2>
        <p>To the maximum extent permitted by law, in no event shall the developer (<strong>Lars Schou Gregersen</strong>) be liable for any indirect, incidental, special, consequential, exemplary, or punitive damages, or for any loss of data, profits, or goodwill, arising out of or related to your use of (or inability to use) the site, software, or demo databases, whether based in contract, tort, strict liability, or otherwise—even if advised of the possibility of such damages.</p>

        <h2>7. Indemnity</h2>
        <p>You agree to indemnify, defend, and hold harmless the developer from and against any claims, liabilities, damages, losses, and expenses (including reasonable attorneys’ fees) arising out of or in any way connected with your use of the site, software, or demo databases; your violation of these Terms; or your violation of any law or the rights of any third party.</p>

        <h2>8. Third-Party Links & Libraries</h2>
        <p>Some software and pages may link to third-party sites or include third-party libraries (e.g., database drivers). Those are subject to their own terms and policies. The developer is not responsible for third-party content, services, or terms.</p>

        <h2>9. Governing Law & Venue</h2>
        <p>These Terms are governed by the laws of <strong>Denmark</strong>, without regard to conflict of law principles. You agree to the exclusive jurisdiction and venue of the courts located in <strong>Copenhagen, Denmark</strong> for any disputes arising from these Terms.</p>

        <h2>10. Termination</h2>
        <p>The developer may suspend or terminate access to any demo environment at any time, with or without notice. You may cease use at any time.</p>

        <h2>11. Changes to These Terms</h2>
        <p>These Terms may be updated from time to time. The Effective date above reflects the latest version. Continued use after changes means you accept the updated Terms.</p>

        <div className="summary div-center">
          <Link to="/contact" className="contact-link">Contact Us</Link>

          <h3>Summary (non-binding)</h3>
          <ul>
            <li>Don’t enter real/personal data.</li>
            <li>Don’t do anything illegal.</li>
            <li>The demo is <strong>as-is</strong> with <strong>no warranty</strong> and <strong>limited/no liability</strong>.</li>
            <li>You’re responsible for what you submit.</li>
            <li>If unsure, ask a lawyer before deploying or distributing.</li>
          </ul>
        </div>
      </div>
    </main>
  )
}
